<template>
  <div class="formRightWrap display_center_ud">
    <div class="formBlock"
         v-if="!isbnid">
      <div class="login_title">
        <span>微信扫码成功</span>
      </div>
      <div class="formWrap">
        <div class="successTip display_center">
          <img :src="imgsrc"
               style="margin-bottom: 10px" />
          <div class="successTipText">
            {{ confirmtext }}
          </div>
        </div>
      </div>
    </div>
    <div class="formBlock"
         v-if="isbnid">
      <div class="login_title">
        <span>绑定手机号</span>
      </div>
      <div class="formWrap">
        <el-form :model="formData"
                 :rules="formRules"
                 ref="FindpswForm">
          <div class="inputBar">
            <el-form-item prop="phone"
                          class="width100">
              <el-input placeholder="请输入手机号码"
                        v-model="formData.phone"></el-input>
            </el-form-item>
          </div>
          <div class="inputBar">
            <el-form-item class="width100">
              <el-input placeholder="请输入验证码"
                        v-model="formData.code"></el-input>
            </el-form-item>
            <div style="margin-left: 5px">
              <a href="javascript:void(0);"
                 v-if="!isdisabled"
                 class="btnNormal"
                 @click="getmsg">
                {{ counttxt }}
              </a>
              <a href="javascript:void(0);"
                 v-if="isdisabled"
                 class="btnNormal">
                {{ counttxt }}
              </a>
            </div>
          </div>
        </el-form>
      </div>
      <div class="marginBottom20">
        <a href="javascript:;"
           v-if="ishowLogin"
           class="btnSubmitok"
           @click="login">确定绑定</a>
        <a href="javascript:;"
           v-if="!ishowLogin"
           class="btnSubmit">确定绑定</a>
      </div>
    </div>
  </div>
</template>

<script>
import sucess from '../../assets/img/icon/sucess.png';
import failure from '../../assets/img/icon/failure.png';
import warn from '../../assets/img/icon/warn.png';
import validate from '../../assets/unit/validate';
export default {
  name: 'wechatlogin',

  data () {
    const VALIDATE_MOBILE_NO = (rule, value, callback) => {
      if (!validate.validateMobile(value)) {
        callback(new Error('手机号需为11位数字'));
      } else {
        callback();
      }
    };
    return {
      confirmtext: '微信扫码成功',
      callbackurl: '',
      imgsrc: sucess,
      redirectUrl: '/home',
      formData: {
        phone: '',
        code: ''
      },
      // 设置按钮是否禁用
      isdisabled: false,
      ishowLogin: false,
      isbnid: false,
      wetchatbnidid: 0,
      formRules: {
        phone: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          { validator: VALIDATE_MOBILE_NO, trigger: 'blur' }
        ]
      },
      timer: null,
      TIME_COUNT: 60,
      count: '',
      counttxt: '点击获取',
      userType: 0
    };
  },
  created () {
    console.log(this.$route.query, '===code')
    if (window.location.href.indexOf('#') != -1) {
      this.wechatcode = window.location.href.split('&')[1].split('=')[1]
      this.callbackurl = decodeURIComponent(window.location.href.split('&')[0].split('?')[1].split('=')[1]);

      this.wechatlogin(this.wechatcode);
    } else {
      if (this.$route.query.code != undefined) {
        this.wechatcode = this.$route.query.code;
        if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'callback')) {
          this.callbackurl = decodeURIComponent(this.$route.query.callback);
          if (Object.prototype.hasOwnProperty.call(this.$route.query, 'cidIng')) {
            this.callbackurl = this.callbackurl + '&cidIng=' + this.$route.query.cidIng;
          }
        }

        this.wechatlogin(this.wechatcode);
      }
    }

  },
  watch: {
    // $route() {
    //     if (this.$route.query.code != undefined) {
    //         alert(this.$route.query.code);
    //     }
    // },
  },
  methods: {
    wechatlogin (wechatcode) {
      this.httphelper
        .post('/api/CGpUserApi/WeChatUserLoginNew', {
          code: wechatcode,
          id: 0,
          LoginType: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            localStorage.setItem('nickname', res.data.data.nickname);
            this.ResData = JSON.stringify(res.data.data);
            localStorage.setItem('ResData', this.ResData);
            var aData = new Date();
            var CurrentDategetTime = 0
            var VipEdDategetTime = 0
            if (res.data.data.memberDate.m_EndDate) {
              var CurrentDate = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate() + ' ' + aData.getHours() + ':' + aData.getMinutes() + ':' + aData.getSeconds();
              var VipEdDate = res.data.data.memberDate.m_EndDate;
              CurrentDategetTime = new Date(CurrentDate.replace(/-/g, '/')).getTime() / 1000;
              VipEdDategetTime = new Date(VipEdDate.replace(/-/g, '/')).getTime() / 1000;
            }
            if (res.data.data.memberDate.m_EndDate == null || parseInt(CurrentDategetTime) - parseInt(VipEdDategetTime) >= 0) {
              this.userType = 0;
            } else {
              if (res.data.data.memberDate.m_Type == 1) {
                this.userType = 1;
              } else if (res.data.data.memberDate.m_Type == 2) {
                this.userType = 2;
              } else {
                this.userType = 0;
              }
            }
            localStorage.setItem('userType', this.userType);
            this.confirmtext = '微信登陆成功，跳转中...';
            // alert(res.data.data.token);
            this.$cookies.set('token_chinagp', res.data.data.token);
            setTimeout(() => {
              if (this.callbackurl != '') {
                if (this.callbackurl.indexOf('?') > -1) {
                  this.redirectUrl = this.callbackurl + '&token=' + res.data.data.token
                } else {
                  this.redirectUrl = this.callbackurl + '?token=' + res.data.data.token
                }
                // this.redirectUrl = this.callbackurl + res.data.data.token;
                window.location.href = this.redirectUrl;
              } else {
                const { href } = this.$router.resolve({
                  path: this.redirectUrl
                });
                window.location.href = href;
              }
            }, 500);
          } else if (res.data.code == 235) {
            this.imgsrc = warn;
            this.$msgmodal({
              title: '系统提示',
              content: '此微信未绑定手机号,请绑定手机号!',
              type: 'warn'
            });
            this.wetchatbnidid = res.data.data.id;
            this.isbnid = true;
            return;
          } else if (res.data.code == 500) {
            this.imgsrc = failure;
            this.confirmtext = '服务器繁忙请稍后再试';
            setTimeout(() => {
              if (this.callbackurl != '') {
                this.redirectUrl = this.callbackurl;
                window.location.href = this.redirectUrl;
              } else {
                const { href } = this.$router.resolve({
                  path: this.redirectUrl
                });
                window.location.href = href;
              }
            }, 1000);
          }
        });
    },
    getVerificationCode () {
      //向服务器获取验证码
      this.httphelper
        .post('/api/VerifCodeApi/NoteVerifCode', {
          type: 7,
          phoneNumber: this.formData.phone
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$msgmodal({
              title: '系统提示',
              content: '发送成功!',
              type: 'ok'
            });
            this.ishowLogin = true;
          } else if (res.data.code == 231) {
            this.$msgmodal({
              title: '系统提示',
              content: '手机号已存在，请直接登录!',
              type: 'warn'
            });
          } else if (res.data.code == 233) {
            this.$msgmodal({
              title: '系统提示',
              content: '发送失败!',
              type: 'warn'
            });
          }
        });
    },
    getmsg () {
      this.$refs.FindpswForm.validate(valid => {
        if (valid) {
          if (this.formData.phone == '') {
            this.$msgmodal({
              title: '系统提示',
              content: '手机号不能为空!',
              type: 'warn'
            });
            return;
          } else {
            var reg = /^1[3456789]\d{9}$/;
            if (!reg.test(this.formData.phone)) {
              this.$msgmodal({
                title: '系统提示',
                content: '手机号不正确!',
                type: 'warn'
              });
              return;
            }
          }
          this.getVerificationCode();
          if (!this.timer) {
            this.count = this.TIME_COUNT;
            this.isdisabled = true;
            this.timer = setInterval(() => {
              // alert(123)
              if (this.count > 0 && this.count <= this.TIME_COUNT) {
                this.counttxt = this.count-- + '秒后重发';
              } else {
                this.counttxt = '重新获取';
                this.isdisabled = false;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      });
    },
    login () {
      this.$refs.FindpswForm.validate(valid => {
        if (valid) {
          //验证,验证码是否正确
          if (this.formData.code == '') {
            this.$msgmodal({
              title: '系统提示',
              content: '验证码不能为空!',
              type: 'warn'
            });
            return;
          }
          this.httphelper
            .post('/api/CGpUserApi/WeChatUserLoginBindMobile', {
              id: this.wetchatbnidid,
              Mobile: this.formData.phone,
              Verifcode: this.formData.code
            })
            .then(res => {
              if (res.data.code == 200) {
                localStorage.setItem('nickname', res.data.data.nickname);
                this.ResData = JSON.stringify(res.data.data);
                localStorage.setItem('ResData', this.ResData);
                var aData = new Date();
                var CurrentDategetTime = 0
                var VipEdDategetTime = 0
                if (res.data.data.memberDate.m_EndDate) {
                  var CurrentDate = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate() + ' ' + aData.getHours() + ':' + aData.getMinutes() + ':' + aData.getSeconds();
                  var VipEdDate = res.data.data.memberDate.m_EndDate;
                  CurrentDategetTime = new Date(CurrentDate.replace(/-/g, '/')).getTime() / 1000;
                  VipEdDategetTime = new Date(VipEdDate.replace(/-/g, '/')).getTime() / 1000;
                }
                if (res.data.data.memberDate.m_EndDate == null || parseInt(CurrentDategetTime) - parseInt(VipEdDategetTime) >= 0) {
                  this.userType = 0;
                } else {
                  if (res.data.data.memberDate.m_Type == 1) {
                    this.userType = 1;
                  } else if (res.data.data.memberDate.m_Type == 2) {
                    this.userType = 2;
                  } else {
                    this.userType = 0;
                  }
                }
                localStorage.setItem('userType', this.userType);
                this.confirmtext = '微信登陆成功，跳转中...';
                // alert(res.data.data.token);
                this.$cookies.set('token_chinagp', res.data.data.token);
                setTimeout(() => {
                  if (this.callbackurl != '') {
                    this.redirectUrl = this.callbackurl;
                    window.location.href = this.redirectUrl;
                  } else {
                    const { href } = this.$router.resolve({
                      path: this.redirectUrl
                    });
                    window.location.href = href;
                  }
                }, 500);
              } else {
                this.$msgmodal({
                  title: '系统提示',
                  content: res.data.msg,
                  type: 'warn'
                });
                return;
              }
            });
        }
      });
    }
  }
};
</script>

<style scoped>
/* 每套全部引入 */
/* 每套页面对应的公共样式,每套页面都会引用 */
.wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
}

input {
    height: 40px;
    border: 1px solid #ddd;
    box-sizing: border-box;
    outline: none;
    padding-left: 12px;
}

.title {
    font-size: 110px;
    color: #fff;
    position: relative;
}

.title:before {
    content: '';
    display: inline-block;
    width: 60px;
    height: 5px;
    background: #ffffff;
    border-radius: 2px;
    position: absolute;
    top: -5px;
}

.titleSub {
    font-size: 40px;
    color: #fff;
    margin-bottom: 20px;
}

.english {
    font-size: 16px;
    color: #ffffff;
}

.english:after {
    content: '————';
    margin-left: 10px;
}

.english img {
    vertical-align: middle;
    margin-right: 10px;
}

.width100 {
    width: 100%;
}

.headBar {
    height: 60px;
}

.headBarRight a {
    margin-right: 30px;
}

.headBarRight a img {
    margin-right: 8px;
}

.content {
    min-width: 1300px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: url('../../assets/img/loginbg.png');
}

.formContent {
    display: flex;
    flex: 1;
}

/* .formRightWrap {  	width: 700px;
} */
.formBlock {
    background: #fff;
    width: 340px;
    padding-top: 40px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 36px;
    border-radius: 30px 0 30px 0;
    box-sizing: border-box;
    position: relative;
}

.bianjiao {
    position: absolute;
    right: 0;
    top: 0;
}

.bianjiaobtn {
    position: absolute;
    right: 40px;
    top: 13px;
    color: #0b8686;
    font-size: 12px;
    width: 76px;
    height: 22px;
    box-sizing: border-box;
    padding-left: 10px;
    line-height: 22px;
    background: url('../../assets/img/login/bianjaiobtn.png');
}

.login_title {
    border-bottom: 1px solid #ddd;
    font-size: 16px;
    margin-bottom: 30px;
}

.login_title span {
    display: inline-block;
    padding: 0 14px;
    padding-bottom: 10px;
    font-weight: bold;
    color: #0b8686;
    border-bottom: 2px solid #0b8686;
}

.login_title a {
    display: inline-block;
    padding: 0 14px;
    padding-bottom: 10px;
    font-weight: bold;
}

.login_title_active {
    color: #0b8686;
    border-bottom: 2px solid #0b8686;
}

.inputBar {
    display: flex;
    margin-bottom: 20px;
}

.btnNormal {
    display: inline-block;
    height: 40px;
    text-align: center;
    line-height: 40px;
    width: 104px;
    background: #1e9fff;
    color: #fff;
    border-radius: 6px;
}

.btnSubmitok {
    width: 100%;
    height: 40px;
    text-align: center;
    display: inline-block;
    line-height: 40px;
    color: #fff;
    background: #0b8686;
}

.btnSubmit {
    width: 100%;
    height: 40px;
    text-align: center;
    display: inline-block;
    line-height: 40px;
    color: #fff;
    background: #e1e1e1;
}

.footer {
    height: 50px;
    background: rgba(255, 255, 255, 0.05);
}

.beian {
    color: #fff;
}

.footer a {
    color: #fff;
    margin-left: 30px;
}

/* 登录2 */
.successTip {
    height: 240px;
    flex-direction: column;
}

.successTipText {
    font-size: 22px;
    color: #0b8686;
    line-height: 1.6em;
}

.Erro {
    border: 1px solid red;
}
</style>
